import { InterruptionEmployeeResponseStatus } from '../../../types';

export enum InterruptionTeamsMessageSkipReason {
  UnsupportedStatus = 'unsupported-status',
  BackendSkipped = 'backend-skipped',
}

export type SendInterruptionTeamsMessageResult = Readonly<{
  sent: boolean;
  reason?: string;
  chatId?: string | null;
  messageId?: string | null;
  skipReason?: string | null;
}>;

export const RESPONSE_STATUSES_TO_MESSAGE = new Set<InterruptionEmployeeResponseStatus>([
  InterruptionEmployeeResponseStatus.Accepted,
  InterruptionEmployeeResponseStatus.Dismissed,
  InterruptionEmployeeResponseStatus.Done,
  InterruptionEmployeeResponseStatus.Postponed,
  InterruptionEmployeeResponseStatus.WillFinishToday,
  InterruptionEmployeeResponseStatus.WillFinishNextCheckin,
]);
